import Imgix from './Imgix';

export default class LightboxGallery {
    constructor() {
        this.imgixInstance = new Imgix(); // register new Imgix instance

        this.currentMedia = [];
        this.imagesRequested = false;
        this.lightboxContainer = document.getElementById('lightbox-gallery');

        this.init();
    }

    init() {
        const closeButton = this.lightboxContainer.querySelector('[data-modal="close"]')

        if(closeButton) {
            closeButton.addEventListener('click', () => this.closeLightbox());
        }

        this.lightboxContainer.addEventListener('click', (event) => {
            const rect = this.lightboxContainer.getBoundingClientRect();
            const isInDialog = (event.clientX >= rect.left && event.clientX <= rect.right &&
                                event.clientY >= rect.top && event.clientY <= rect.bottom);
            if (!isInDialog) this.closeLightbox();
        });

        document.body.addEventListener('keydown', (e) => {
            if (!document.body.classList.contains('lightbox-open')) return

            if (e.key === "Escape") this.closeLightbox();
        });

        document.querySelectorAll('[data-lightbox="gallery"]').forEach((gallery) => {
            const mediaElements = gallery.querySelectorAll('img, video'),
                buttonTrigger = gallery.closest('figure')?.querySelector('[data-lightbox="trigger"]'),
                isImageTrigger = gallery.hasAttribute('data-lightbox-image-trigger');

            if (isImageTrigger) {
                mediaElements.forEach((media) => {
                    media.addEventListener('click', (e) => this.openLightbox(gallery, e.target));
                });
            }

            buttonTrigger?.addEventListener('click', () => {
                const activeImage = gallery.querySelector('.swiper-slide-active > *');
                const targetImage = activeImage || mediaElements[0];
                this.openLightbox(gallery, targetImage);
            });
        });
    }

    openLightbox(gallery, clickedMedia) {

        // Filter only visible media (non .is-inactive)
        let mediaElements = Array.from(gallery.querySelectorAll('img, video'))
            .filter(media => {
                // Skip if inside .is-inactive
                if (media.closest('.exclude-from-gallery, .is-inactive')) return false;

                // Skip the first media inside a widget: e.g. .c-cta--stack-images
                // if (!skipped && media.closest('.c-cta--stack-images')) {
                //     skipped = true;
                //     return false;
                // }

                return true;
            });

        // Re-assign data-gallery-index to only visible media
        mediaElements.forEach((media, index) => {
            media.setAttribute('data-gallery-index', index);

            // Set from parent swiper-slide if available
            const swiperIndex = media.closest('.swiper-slide')?.dataset.swiperSlideIndex;
            if (swiperIndex !== undefined) {
                media.setAttribute('data-swiper-slide-index', swiperIndex);
            }
        });


        // Sort media based on new data-gallery-index
        mediaElements = mediaElements.sort((a, b) => {
            const indexA = parseInt(a.closest('.swiper-slide')?.getAttribute('data-swiper-slide-index') ?? a.getAttribute('data-gallery-index'), 10);
            const indexB = parseInt(b.closest('.swiper-slide')?.getAttribute('data-swiper-slide-index') ?? b.getAttribute('data-gallery-index'), 10);

            return indexA - indexB;
        });

        // Store current visible media for rendering
        this.currentMedia = mediaElements.map(media => ({
            src: media.dataset.src || media.src || media.currentSrc,
            type: media.tagName.toLowerCase(),
        }));

        // rather than using the indexes we utilise the source as this prevents the logical parity errors caused if sliders / galleries misalign
        this.clickedMediaSrc = (clickedMedia.dataset.src || clickedMedia.src || clickedMedia.currentSrc)//.split('?')[0]; // <- split to remove parameters if needed

        // Render the lightbox with visible media
        this.renderLightbox().then((current) => {
            this.imgixInstance.process(this.lightboxContainer)

            setTimeout(() => {
                current.scrollIntoView({ behavior: 'smooth' });
            }, 100);
        });

        this.lightboxContainer.showModal();
        document.body.classList.add('lightbox-open');
    }

    // returning this as a promise to ensure that swiper is fully initiallised before showing the modals
    renderLightbox() {
        return new Promise((resolve) => {

            const lightBoxWrapper = this.lightboxContainer.querySelector('.o-media-container__media-wrapper');
            lightBoxWrapper.innerHTML = '';

            this.currentMedia.forEach(({ src, type }) => {
                let media;

                if (type === 'img') {
                    media = document.createElement('img');
                    media.className = 'o-media-container__media imgix-fluid img-fit o-image';
                    media.dataset.src = src;
                } else if (type === 'video') {
                    media = document.createElement('video');
                    media.className = 'o-media-container__media lightbox-video';
                    media.controls = true;
                    media.autoplay = (src === this.clickedMediaSrc) ? true : false;
                    media.muted = (src === this.clickedMediaSrc) ? false : true;

                    const sourceEl = document.createElement('source');
                    sourceEl.src = src;
                    sourceEl.type = 'video/mp4';
                    media.appendChild(sourceEl);
                }

                if(src == this.clickedMediaSrc) {
                    media.className += ' clicked';
                }

                lightBoxWrapper.appendChild(media);
            });

            let current = lightBoxWrapper.querySelector('.clicked');

            resolve(current);
        });
    }

    closeLightbox() {
        this.lightboxContainer.close(); // Use the close() method to close the dialog
        document.body.classList.remove('lightbox-open');
        this.imagesRequested = false;
        this.pauseAllVideos();
    }

    pauseAllVideos() {
        this.lightboxContainer.querySelectorAll('video').forEach((video) => {
            video.pause();
        });
    }
}
